module.exports = __webpack_public_path__ + "img/seminar_seminar.2d7dde5e.jpg";